import styles from "./OttBanner.module.scss";
import classNames from "classnames";
import type { OttBanner } from "@motain/xpa-proto-files-web/lib/types/ott-banner";
import type { FC } from "react";
import { ButtonLink } from "@/components/button/ButtonLink";
import { trackingService } from "@/modules/analytics";
import { EventType } from "@motain/xpa-proto-files-web/lib/types/tracking";
import { EntityLogo } from "@/components/entity-logo/EntityLogo";
import { isNonNullable } from "@/types/isNonNullable";

export const OttBannerComponent: FC<OttBanner> = (props) => {
  const { link, logo, broughtBy } = props;

  return (
    <div className={styles.container}>
      <div className={styles.cta_content}>
        <p className={classNames(styles.cta__text, "title-6-medium")}>
          {props.message}
        </p>

        {isNonNullable(link) && (
          <ButtonLink
            isClientNavigation
            href={link.urlPath}
            variant="fill"
            executeOnClick={[
              () => {
                if (isNonNullable(link.trackingEvents)) {
                  trackingService.sendXpaTracking(
                    link.trackingEvents,
                    EventType.EVENT_CLICK,
                  );
                }
              },
            ]}
            type="submit"
            className={"title-7-medium"}
          >
            {link.name}
          </ButtonLink>
        )}
      </div>

      <div className={classNames(styles.broughtBy, "text-4")}>
        <p className={styles.broughtBy__text}>{broughtBy}</p>
        {isNonNullable(logo?.path) && (
          <EntityLogo
            src={logo?.path ?? ""}
            alt={"provider-logo"}
            className={styles.broughtBy__logo}
          />
        )}
      </div>
    </div>
  );
};
